import { Component, ViewChild, ElementRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import Swal from 'sweetalert2';

@Component({
  selector: 'checkbox-cell',
  template: `   <div [class]="_checkboxdiv"> <input type="checkbox"  
                  (change)="onChange($event)" [class]="_checkbox" [(checked)]="isChecked" [disabled]="isDisabled"/></div>`,
  styles: [`.check-wh16px{ width: 16px; height: 16px; margin-top: 4px }`],
})
export class CheckboxCellComponent implements ICellRendererAngularComp {
  @ViewChild('.checkbox') checkbox: ElementRef;
  divcheckboxtype = { checkbox: 'form-check form-switch-md', switch: 'form-check form-switch form-switch-md' }
  checkboxtype = { checkbox: 'form-check-input check-wh16px', switch: 'form-check-input' }
  //by default
  _checkboxdiv = this.divcheckboxtype.switch;
  _checkbox = this.checkboxtype.switch;

  public params: any; isChecked = false;
  isDisabled = false; confirmMsg: any = '';
  constructor() { }
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
  agInit(params: any): void {
    this.params = params;
    this.isChecked = this.params?.data?.isactive;
    // console.log(this.params);
    // console.log("params", params);

    switch (this.params.context.componentName) {
      case 'ListManifestComponent':
        this.confirmMsg = `<span>You want to <b>Dispatch</b><i class="mdi mdi-truck-check font-size-16 align-middle ms-1">
                            </i> this Manifest.</span><br><span>Once dispached can't be modified</span>`;
        this.isChecked = this.params?.data.isclosed;
        this.isDisabled = this.params?.data.isclosed;
        break;

      case 'DRSComponent':
        this.isChecked = this.params?.data?.isundelivered;
        this.isDisabled = this.isChecked;
        this.confirmMsg = 'You want to mark this shipment as <b>NOT DELIVERED</b>';
        break;

      case 'ListExpenseComponent':
        this.isChecked = this.params?.data?.authorized == "Yes";
        this.isDisabled = this.isChecked;
        this.confirmMsg = 'You want to <b> Approved this expense.</b>';
        break;

      case 'InvoiceSeriesComponent':
        this.confirmMsg = 'You want to mark it as Active';
        break;

      case 'AddUsersComponent':
      case 'EditUsersComponent':
        this._checkboxdiv = this.divcheckboxtype.checkbox;
        this._checkbox = this.checkboxtype.checkbox;
        this.isChecked = this.params?.data?.isdefault || false;
        this.isDisabled = this.params?.data?.isDisabled || false;
        this.confirmMsg = `You want to mark it as Default`;
        break;

      case 'AddCustomerComponent':
      case 'EditCustomerComponent':
        this._checkboxdiv = this.divcheckboxtype.checkbox;
        this._checkbox = this.checkboxtype.checkbox;
        this.isChecked = this.params?.data?.isbilling || false;
        this.isDisabled = this.params?.data?.disabled || false;
        this.confirmMsg = `You want to mark it as Billing Service Center`;
        break;

      case 'AddManifestComponent':
        this._checkboxdiv = this.divcheckboxtype.checkbox;
        this._checkbox = this.checkboxtype.checkbox;
        this.isChecked = this.params?.data?.isactive;
      // console.log(this.params?.data);

      default:
        break;
    }
  }

  public async onChange(event) {

    // console.log("this.params.context.componentName : ",this.params.context.componentName);

    // this.params.data[this.params.colDef.field] = event.currentTarget.checked;
    this.isChecked = !this.isChecked;
    let result = {
      event: event,
      data: this.params,
      rowdata: this.params.data,
      checked: event.target.checked
    }

    
    if (this.isChecked && !this.params?.data?.isactive && this.params.context.componentName == 'AddManifestComponent') {
      this.params.data.isactive = true;
      this.params.context.componentParent.onCheckBoxChange(result);
      return;
    } else if (!this.isChecked && this.params?.data?.isactive && this.params.context.componentName == 'AddManifestComponent') {
      this.isChecked = !this.isChecked;
      this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
      this.params.context.componentParent.onCheckBoxChange(result);
      return;
    }

    if (this.isChecked === true) {
      let confirmed = false;
      if(this.params.context.componentName == 'DRSComponent'){
          const confirmedRes = await this.openUndeliveredDialog(`<span>Are you sure ?</span><br><span>${this.confirmMsg}.</span>`);
          confirmed = confirmedRes.confirmed;
          result.rowdata.reason = confirmedRes.reason;
      }else{
          confirmed = await this.openConfirmationDialog(`<span>Are you sure ?</span><br><span>${this.confirmMsg}.</span>`);
      }
      if (confirmed) {
        this.params.context.componentParent.onCheckBoxChange(result);
      } else {
        this.isChecked = !this.isChecked;
        this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
      }
    } else if (this.isChecked === false && (this.params.context.componentName == 'AddUsersComponent' || this.params.context.componentName == 'EditUsersComponent')) {
      const confirmed = await this.openWarningDialog(`<span>At least one service center should be default.</span>`);
      if (confirmed) {
        this.isChecked = !this.isChecked;
        this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
      }
    }

  }

  async openConfirmationDialog(msg: any): Promise<boolean> {
    const result = await Swal.fire({
      // titleText: 'Confirmation',
      html: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    return result.isConfirmed;
  }

  async openWarningDialog(msg: any): Promise<boolean> {
    const result = await Swal.fire({
      // titleText: 'Opps!',
      html: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    return result.isConfirmed;
  }

  async openUndeliveredDialog(msg: any) {
    const result = await Swal.fire({
        icon: 'warning',
        html: msg,
        confirmButtonText: 'Yes',
        showDenyButton: true,
        denyButtonText: 'No',
        allowOutsideClick: false,
        allowEscapeKey: false,
        input: 'textarea',
        inputPlaceholder: 'Reason',
        inputAttributes: {
            maxlength: '250'
        },
        preConfirm: (value) => {
            if (!value) {
                Swal.showValidationMessage('Reason is required');
            }
        }
    });

    if (result.isConfirmed) {
        return {
            confirmed: true,
            reason: result.value
        };
    } else {
        return {
            confirmed: false,
            reason: null
        };
    }
}

  
}
